import React from "react";
import clsx from "clsx";

import "./TextField.scss";

type TextFieldProps = {
    id?: string;
    className?: string;
    type?: "default-input" | "floating-input";
    inputType?: string;
    placeholder?: string;
    classes?: string;
    name?: string;
    icon?: string;
    value?: string | number;
    required?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    hasError?: boolean;
    errorMessage?: string;
    reverseIcon?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

export function TextField({
  id,
  className,
  type = "default-input",
  inputType = "text",
  reverseIcon = false,
  placeholder,
  name,
  icon,
  value,
  required,
  disabled,
  readonly,
  hasError,
  errorMessage,
  classes,
  onChange = (e) => {},
  onFocus = (e) => {},
}: TextFieldProps) {
    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        if (onChange) onChange(e);
    }

    function handleFocus(e: React.FocusEvent<HTMLInputElement>) {
        if (onFocus) onFocus(e);
    }

    return (
        <div className={`${type} ${className}`}>
            <div
                className={clsx("text-field-wrap", {
                    "has-icon": !!icon,
                })}
            >
                {!reverseIcon && icon && <span className={`text-field-icon icon-${icon}`}></span>}

                <input
                    id={id}
                    type={inputType}
                    data-testid={id}
                    className={clsx("form-field", {
                        "has-error": hasError,
                        disabled: disabled,
                    })}
                    name={name}
                    value={value}
                    placeholder={type === "default-input" ? placeholder : ""}
                    required={required}
                    readOnly={readonly}
                    disabled={disabled}
                    onFocus={handleFocus}
                    onChange={handleChange}
                />

                {reverseIcon && icon && <span className={`text-field-icon icon-${icon}`}></span>}

            </div>

            {type === "floating-input" && <label htmlFor={id}>{placeholder}</label>}

            {hasError && errorMessage && (
                <div className="form-field__error-message">{errorMessage}</div>
            )}
        </div>
    );
}
